export enum AutoRenewFormFields {
  AutoRenewal = 'autoRenewal',
}
